import { forwardRef } from 'react';
import MultiSelect from '../../../MultiSelect';
import Select from '../../../Select';
import { IBaseField, ISelectField } from '../../types';
import WrapperFormField from '../WrapperFormField';
const SelectField = forwardRef((props: IBaseField & ISelectField, ref) => {
  const { label, name, multiple, error, create, hideBtnClear, maxItem, ...rest } = props;
  return (
    <WrapperFormField label={label} ref={ref} description={rest.description}>
      {multiple ? (
        <MultiSelect {...rest} hideClear={hideBtnClear} maxItem={maxItem} create={create} name={name} error={error} />
      ) : (
        <Select {...rest} name={name} error={error} />
      )}
    </WrapperFormField>
  );
});

export default SelectField;
